import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface LifetimeState {
  lifetime: number
  set: (value: number) => void
}

export const useLifetimeStore = create<LifetimeState>()(
  persist(
    (set) => ({
      lifetime: 66,
      set: (value: number) => set({ lifetime: value }),
    }),
    {
      name: 'lifetime-storage', // key in localStorage
    }
  )
)
